export const isDriverSafetyView: boolean = window.location.href.includes('driver-scorecard') ||
  window.location.href.includes('driver-safety');
